import {
  Input,
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { ProductService } from 'services/product.service';
import visaRequirementHtml from './visa-requirement.html';
import './visa-requirement.scss';
import { SearchService } from 'services/search.service';
import * as $ from 'jquery';

@Component({
  selector: 'gw-search-visa-requirement',
  template: visaRequirementHtml,
})
export class SearchVisaRequirementComponent implements OnInit {
  public GW = (<any>window).GW;
  public laroute = (<any>window).laroute;

  public search;
  public visaProducts;
  public loading: Boolean = false;
  public globalSearch;

  @Input() country: string;

  constructor(
    @Inject('$filter') private $filter,
    @Inject(ProductService) private productService: ProductService,
    @Inject('$timeout') private $timeout: ng.ITimeoutService,
    @Inject('$scope') private $scope: ng.IScope,
    @Inject(SearchService) protected searchService: SearchService,
  ) {}

  ngOnInit() {
    this.search = {
      visa: null,
      citizenship: this.GW.geoip.iso_code || 'US',
      residency: this.GW.geoip.state || 'FL',
      countryName: this.$filter('country')(this.country) || '',
    };

    this.getVisaProducts();
  }

  async getVisaProducts() {
    try {
      this.loading = true;
      this.visaProducts = await this.productService
        .getList(this.country,
                 'visa',
                 '',
                 this.search.citizenship,
                 this.search.residency);

    } catch (e) {
      console.log(e);

    } finally {
      // FIXME: without $apply the view is not refreshed
      this.$scope.$apply(() => {
        this.loading = false;
      });
    }
  }

  onCitizenshipUpdated() {
    // FIXME: without $timeout this.search.citizenship value is outdated
    this.$timeout(() => {
      this.getVisaProducts();
    }, 100);
  }

  goToVisaPage() {
    const citizenship = this.$filter('country')(this.search.citizenship);
    const route = this.laroute.route('visas.product', {
      destination: this.$filter('slugify')(this.search.countryName),
      product: this.search.visa,
      citizenship: this.$filter('slugify')(citizenship),
      residency: this.search.residency.toLocaleLowerCase(),
    });

    // update the search
    this.globalSearch = this.searchService.getSearch(true);
    if (this.globalSearch.rows.length === 0) {
      this.searchService.addSearchRow();
    }
    this.globalSearch.rows[0].params.citizenship = {
      code: this.search.citizenship,
      label: citizenship,
    };
    this.globalSearch.rows[0].params.destination = {
      code: this.country,
      label: this.search.countryName,
    };
    this.searchService.updateSearch(this.globalSearch);

    window.location.assign(route);
  }

  /**
   * When a md-select-backdrop exist the page can't be scrolled
   * but the default angular scroll blocker is not working
   *
   * @param show
   */
  onShow(show: boolean) {
    $('html, body')
      .css('overflow', show ? 'hidden' : 'auto');
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/visa-requirement/visa-requirement.component.ts